import {
  USER_ADD_TEMP_FILE_ACTION_BEGIN,
  USER_ADD_TEMP_FILE_ACTION_SUCCESS,
  USER_ADD_TEMP_FILE_ACTION_FAILURE,
  USER_ADD_TEMP_FILE_ACTION_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/upload'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function addTempFileAction(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: USER_ADD_TEMP_FILE_ACTION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      request({
        url:'/api/basic/template',
        data: args
      }).then(
        (res) => {
          dispatch({
            type: USER_ADD_TEMP_FILE_ACTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_ADD_TEMP_FILE_ACTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissAddTempFileActionError() {
  return {
    type: USER_ADD_TEMP_FILE_ACTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_ADD_TEMP_FILE_ACTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        addTempFileActionPending: true,
        addTempFileActionError: null,
      };

    case USER_ADD_TEMP_FILE_ACTION_SUCCESS:
      // The request is success
      return {
        ...state,
        addTempFileActionPending: false,
        addTempFileActionError: null,
      };

    case USER_ADD_TEMP_FILE_ACTION_FAILURE:
      // The request is failed
      return {
        ...state,
        addTempFileActionPending: false,
        addTempFileActionError: action.data.error,
      };

    case USER_ADD_TEMP_FILE_ACTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        addTempFileActionError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/addTempFileAction.js